// src/api/paymentApi.js

import apiClient from './apiClient';

const paymentClient = apiClient('payments');

const paymentApi = {
    /**
     * Проверка оплаты по promoId.
     * POST /payments/check  { promoId }
     */
    async checkPayment(promoId) {
        const res = await paymentClient.post('check', { promoId });
        return res.data;
    },

    /**
     * Создание оплаты.
     * POST /payments  CreatePaymentDto
     */
    async createPayment(data) {
        const res = await paymentClient.post('', data);
        return res.data;
    },

    /**
     * Отмена оплаты по promoId.
     * POST /payments/cancel/:promoId
     */
    async cancelPayment(promoId) {
        const res = await paymentClient.post(`cancel/${promoId}`);
        return res.data;
    },

    /**
     * Получить все платежи (без промо).
     * GET /payments
     */
    async getAllPayments() {
        const res = await paymentClient.get('');
        return res.data;
    },

    /**
     * Получить платежи вместе с данными промо.
     * GET /payments/with-promos
     * @param options.paid     true | false | undefined — фильтр по оплате
     * @param options.page     number — номер страницы (1-based)
     * @param options.pageSize number — сколько записей на страницу
     */
    async getAllWithPromos({ paid, page = 1, pageSize = 20 } = {}) {
        const params = {};
        if (paid !== undefined) params.paid = paid;
        params.page = page;
        params.pageSize = pageSize;

        const res = await paymentClient.get('with-promos', { params });
        return res.data;
    },
};

export default paymentApi;
